/**
 * Generated by orval v8.16.0 🍺
 * Do not edit manually.
 * FinPath API
 * Backend API programu FinPath (panel admina + aplikacja mobilna).
 * OpenAPI spec version: 0.1.0
 */

/**
 * * `notConfigured` - Nie skonfigurowano
 * * `configured` - Skonfigurowane
 * * `scheduled` - Zaplanowane
 * * `inProgress` - Wysyłanie
 * * `completed` - Zakończone
 * * `completedWithErrors` - Zakończone z błędami
 * * `transportDisabled` - Transport niedostępny
 * * `failed` - Niepowodzenie
 * * `skipped` - Pominięte
 */
export type ReminderStatusEnum = typeof ReminderStatusEnum[keyof typeof ReminderStatusEnum];


export const ReminderStatusEnum = {
  notConfigured: 'notConfigured',
  configured: 'configured',
  scheduled: 'scheduled',
  inProgress: 'inProgress',
  completed: 'completed',
  completedWithErrors: 'completedWithErrors',
  transportDisabled: 'transportDisabled',
  failed: 'failed',
  skipped: 'skipped',
} as const;
